module.exports = __webpack_public_path__ + "static/Group 7132-8efba0b9fc87eb5869339d5c9b1eda5a.png";